import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { Box, Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { memo, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../../../../../App";
import Scale from "assets/images/scale.png";
import {
  addRestaurantProducts,
  deleteItemThroughScanner,
  deletePorductFromCart,
  editCart,
  repeatOrder,
  updateProductQuantityOnCart,
} from "../../../../../../config/Services";
import { eventTrackerConstant } from "../../../../../common/event-tracker/event-tracker-constants";
import { eventTracker } from "../../../../../common/event-tracker/eventTracker";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { normalizeNumber } from "../../Middleware/commonUtils";
import { getStoreCurrencySymbol } from "../../../../../../utils/currency";
import { addcoupon } from "../../redux/Actions/couponActions";
import { setManuallyRemovedItems } from "../../redux/Actions/eventTracker";
import { getFullState, getManuallyRemovedItems } from "../../redux/Reducers/eventTrackerReducer";
import "./CartItem.css";
import DeleteIcon from "@mui/icons-material/Delete";
import vegIcon from "../../../../../../assets/images/veg-new.png";
import nonVegIcon from "../../../../../../assets/images/non-veg-icon.svg";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { ChatBubbleLeftRightIcon, TrashIcon } from "@heroicons/react/24/outline";
import counterPlus from "../../../../../../assets/images/counter-plus.png";
import counterMinus from "../../../../../../assets/images/counter-minus.png";
import { ArrowPathIcon, ChevronRightIcon, GiftIcon } from "@heroicons/react/20/solid";
import { set } from "lodash";
import AddonModal from "../AddonModal/AddonModal";
import RecallOrderModal from "../RecallOrderModal/RecallOrderModal";
import ProductCommentModal from "../../ProductCommentModal";
import useAuthModal from "../../../hooks/useAuthModal";

const CartItem = ({
  ele,
  index,
  decreaseItemQuantity,
  increaseItemQuantity,
  increaseCartItemLoader,
  animationBox,
  gtinItem,
  highlightMrp,
  setDisableProceed,
  setShowFineDineActionButtons,
  setHasRequestedForNewItem,
  isHighlighted,
  isKeyboardFocused,
}) => {
  const showSnackbar = useSnackbar();
  const [cartQuantity, setCartquantity] = useState("");
  const cartId = localStorage.getItem("CartId");
  const locId = localStorage.getItem("locId");
  const orgId = localStorage.getItem("orgId");
  const branchSubType = localStorage.getItem("branchSubType");
  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));
  const {
    setTotal,
    setCartItems,
    setCartTotalQty,
    setSubTotal,
    setCgst,
    setSgst,
    setOfferFound,
    setTotalValue,
    setCess,
    saleMode,
    setHighlightedCartProductId,
    setTotalTaxes,
    setCartBilling,
    setTaxes,
  } = useContext(UserContext);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [increaseLoader, setIncreaseLoader] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleClose = () => setOpenDelete(false);
  const dispatch = useDispatch();
  const [isOffer, setIsOffer] = useState(false);
  const [addOnModalOpen, setAddOnModalOpen] = useState(false);
  const { setanimationBox } = useContext(UserContext);
  const { setItemgtin, setHighlightMrp, cartItems } = useContext(UserContext);
  var myDiv = document.getElementById("scrollTopDiv");
  const removedItems = useSelector(getManuallyRemovedItems);
  const orderMetricDataFullState = useSelector(getFullState);
  const retailType = localStorage.getItem("retailType");
  const { particularCategoryItems, setparticularCategoryItems } = useContext(UserContext);
  const [couponApplied, setCouponApplied] = useState("0");
  const [updateResponseCartTime, setUpdateResponseCartTime] = useState(() => {
    const item = localStorage.getItem("updateCartResponseTime");
    try {
      return item ? JSON.parse(item) : [];
    } catch (error) {
      console.error("Error parsing 'updateCartResponseTime' from localStorage", error);
      return [];
    }
  });
  const [repeatOrderLoader, setRepeatOrderLoader] = useState(false);
  const [recallOrderModalOpen, setRecallOrderModalOpen] = useState(false);
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const { renderAuthModal, openAuthModal } = useAuthModal();

  // Open comment modal via Enter when this cart item is keyboard-focused
  useEffect(() => {
    if (!isKeyboardFocused) return;
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        setCommentModalOpen(true);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isKeyboardFocused]);

  const appConfigData = localStorage.getItem("appConfig");
  const appConfig = appConfigData ? JSON.parse(localStorage.getItem("appConfig")) : {};
  const managerPinRequiredForRecall = appConfig?.enabledFeatures?.RECALL_MANAGER_PIN_AUTH;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    color: "black",
  };

  // Helper function to truncate long text
  const truncateText = (text, maxLength = 50) => {
    if (!text) return "";
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  useMemo(() => {
    if (ele?.sellingUnit === "nos" || ele?.sellingUnit === "no") setCartquantity(ele?.quantity);
    else
      setCartquantity(
        (ele?.quantityBySpecs && parseFloat(ele?.quantityBySpecs).toFixed(2)) || ele?.quantity
      );
  }, [ele]);

  const isWeighingBarcode = useMemo(() => !!ele?.quantityBySpecs, [ele]);
  const isProfilerOn = localStorage.getItem("profilerSwitch") === "true";

  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails")) || {};

  const handleSubmitEdit = async (item) => {
    setIncreaseLoader(true);
    setHighlightMrp(item?.sellingPrice);

    const addOnProductList = item?.addonProduct.map((addOnEle) => ({
      variantId: addOnEle?.variantId || "",
      itemName: addOnEle?.itemName || "",
      sellingPrice: addOnEle?.sellingPrice || 0,
      sellingUnit: addOnEle?.sellingUnit || "",
      specification: addOnEle?.specification || "",
      igst: addOnEle?.igst || 0,
      igstAmount: 0,
      cgst: 0,
      cgstAmount: 0,
      sgst: 0,
      sgstAmount: 0,
      cess: 0,
      cessAmount: 0,
    }));

    const payload = {
      cartId: cartId,
      cartProductId: item?.cartProductId,
      sellingPrice: item?.sellingPrice,
      qty: isWeighingBarcode ? 1 : cartQuantity,
      quantityBySpecs: isWeighingBarcode ? cartQuantity : null,
      sellingUnit: item?.sellingUnit,
    };

    if (retailType == "RESTAURANT") {
      const restaurantPayload = {
        cartId: cartId,
        cartProductId: item?.cartProductId,
        sellingPrice: item?.sellingPrice,
        variantId: item?.variantId,
        vendorId: item?.vendorId || "",
        ...(item?.packagingType === "weighingScale" ? { qty: 1 } : { qty: Number(cartQuantity) }),
        locationId: locId,
        mrp: item?.sellingPrice || 0,
        purchasePrice: item?.purchasePrice || 0,
        sellingUnit: item?.sellingUnit || "",
        ...(item?.packagingType === "weighingScale" && { quantityBySpecs: Number(cartQuantity) }),
        productStatus: item.productStatus,
        addonProducts: addOnProductList,
      };

      try {
        const itemFound = cartItems?.find((cartItem) => cartItem?.gtin === item?.gtin);
        if (cartQuantity === "0") {
          handleCartDelete(item);
          setIncreaseLoader(false);
        } else {
          await updateProductQuantityOnCart(restaurantPayload)
            .then((res) => {
              if (Number(cartQuantity) < itemFound?.quantity && cartQuantity !== "0") {
                const metaData = {
                  itemId: payload?.gtin,
                  quantity: itemFound?.quantity - Number(cartQuantity),
                  sellingPrice: payload?.sellingPrice,
                  cartId: payload?.cartId,
                  mrp: payload?.mrp,
                };
                eventTracker({ metaData, eventType: eventTrackerConstant.CART_ITEM_REMOVED });
              }
              const sortedProducts = res?.data?.data?.data?.cartProducts.sort((a, b) =>
                b?.modifiedDate.localeCompare(a?.modifiedDate)
              );
              setCartItems(sortedProducts);
              // Highlight the modified product
              if (sortedProducts?.[0]?.cartProductId) {
                setHighlightedCartProductId(sortedProducts[0].cartProductId);
                setTimeout(() => setHighlightedCartProductId(null), 2000);
              }
              setOfferFound(res?.data?.data?.data?.offerProductFound);
              setTotal(res?.data?.data?.data?.billing?.totalCartValue);
              setTotalValue(res?.data?.data?.data?.billing?.totalValue);
              setSubTotal(res?.data?.data?.data?.billing?.subtotal);
              setCgst(res?.data?.data?.data?.billing?.cgst);
              setSgst(res?.data?.data?.data?.billing?.sgst);
              setCess(res?.data?.data?.data?.billing.totalCessAmount);
              setCouponApplied(res?.data?.data?.data?.cartCoupon?.couponValue);
              dispatch(addcoupon(res?.data?.data?.data?.cartCoupon));
              setIncreaseLoader(false);
              setanimationBox(true);
              setItemgtin(item?.gtin);
              myDiv.scrollTop = 0;
              myDiv.scrollTop = 0;
              quantityInputRef.current?.blur();
            })
            .catch((err) => {
              setIncreaseLoader(false);
            });
        }
      } catch (err) {
        showSnackbar(err?.message || err || "Something went wrong", "error");
      }
    } else {
      const itemFound = cartItems?.find((cartItem) => cartItem?.gtin === item?.gtin);
      if (cartQuantity === "0") {
        handleCartDelete(item);
        setIncreaseLoader(false);
      }
      const start = new Date().getTime();
      await editCart(payload, cartId, locId)
        .then((res) => {
          if (isProfilerOn) {
            const end = new Date().getTime();
            const timeTaken = end - start;
            const updatedCartUpdateResponseTimes = [
              ...updateResponseCartTime,
              { time: end, responseTime: timeTaken },
            ];
            localStorage.setItem(
              "updateCartResponseTime",
              JSON.stringify(updatedCartUpdateResponseTimes)
            );
            setUpdateResponseCartTime(updatedCartUpdateResponseTimes);
          }
          if (Number(cartQuantity) < itemFound?.quantity && cartQuantity !== "0") {
            const metaData = {
              itemId: payload?.gtin,
              quantity: itemFound?.quantity - Number(cartQuantity),
              sellingPrice: payload?.sellingPrice,
              cartId: payload?.cartId,
              mrp: payload?.mrp,
            };
            eventTracker({ metaData, eventType: eventTrackerConstant.CART_ITEM_REMOVED });
          }
          const sortedProducts = res?.data?.data?.data?.cartProducts.sort((a, b) =>
            b?.modifiedDate.localeCompare(a?.modifiedDate)
          );
          setCartItems(sortedProducts);
          // Highlight the modified product
          if (sortedProducts?.[0]?.cartProductId) {
            setHighlightedCartProductId(sortedProducts[0].cartProductId);
            setTimeout(() => setHighlightedCartProductId(null), 2000);
          }
          setOfferFound(res?.data?.data?.data?.offerProductFound);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setSubTotal(res?.data?.data?.data?.billing?.subtotal);
          const billingObj = res?.data?.data?.data?.billing;
          if (billingObj) {
            setCartBilling?.(billingObj);
            if (Array.isArray(billingObj.taxes)) setTaxes?.(billingObj.taxes);
          }
          setIncreaseLoader(false);
          setanimationBox(true);
          setItemgtin(item?.gtin);
          myDiv.scrollTop = 0;
          quantityInputRef.current?.blur();
        })
        .catch((err) => {
          setIncreaseLoader(false);
        });
    }
  };

  const deleteCartItem = () => {
    setOpenDelete(true);
  };

  const handleCartDelete = (item) => {
    setDeleteLoader(true);
    if (retailType === "RESTAURANT") {
      const restaurantPayload = {
        cartId: cartId || "",
        cartProductId: item?.cartProductId,
      };
      deletePorductFromCart(restaurantPayload)
        .then((res) => {
          dispatch(setManuallyRemovedItems(removedItems + 1));
          const backupData = {
            ...orderMetricDataFullState,
            manuallyRemovedItems: removedItems + 1,
          };
          localStorage.setItem("orderMetricData", JSON.stringify(backupData));
          const itemFound = cartItems.find((cartItem) => cartItem?.gtin === item?.gtin);
          const metaData = {
            quantity: itemFound?.quantity,
            cartId: restaurantPayload?.cartId,
          };
          eventTracker({ metaData, eventType: eventTrackerConstant.CART_ITEM_REMOVED });
          showSnackbar("Success item removed", "success");
          setCartItems(
            res?.data?.data?.data?.cartProducts.sort((a, b) =>
              b?.modifiedDate.localeCompare(a?.modifiedDate)
            )
          );
          setOfferFound(res?.data?.data?.data?.offerProductFound);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing.totalCessAmount);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setSubTotal(res?.data?.data?.data?.billing?.subtotal);
          setDeleteLoader(false);
          setOpenDelete(false);
          dispatch(addcoupon(res?.data?.data?.data?.cartCoupon));
          const cartProducts = res?.data?.data?.data?.cartProducts;
          const isOutOfStck = cartProducts?.find(
            (item) => item?.inventoryStatus === "OUT_OF_STOCK"
          );
          setDisableProceed(!!isOutOfStck);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.data?.message || err?.message, "error");
          setDeleteLoader(false);
          setOpenDelete(false);
        });
    } else {
      const payload = {
        cartId: cartId,
        sellingPrice: item?.sellingPrice,
        gtin: item?.gtin,
        locationId: locId,
        mrp: item?.mrp,
        inventoryChecks: "NO",
        batchNo: item?.batchNo,
        purchasePrice: item?.purchasePrice || "",
        quantity: item?.quantity,
        quantityBySpecs: item?.quantityBySpecs,
        sellingUnit: item?.sellingUnit,
      };
      deleteItemThroughScanner(payload)
        .then((res) => {
          dispatch(setManuallyRemovedItems(removedItems + 1));
          const backupData = {
            ...orderMetricDataFullState,
            manuallyRemovedItems: removedItems + 1,
          };
          localStorage.setItem("orderMetricData", JSON.stringify(backupData));
          const itemFound = cartItems.find((cartItem) => cartItem?.gtin === item?.gtin);
          const metaData = {
            itemId: payload?.gtin,
            quantity: itemFound?.quantity,
            sellingPrice: payload?.sellingPrice,
            cartId: payload?.cartId,
            mrp: payload?.mrp,
          };
          eventTracker({ metaData, eventType: eventTrackerConstant.CART_ITEM_REMOVED });
          showSnackbar("Success item removed", "success");
          setCartItems(
            res?.data?.data?.cartProducts.sort((a, b) =>
              b?.modifiedDate.localeCompare(a?.modifiedDate)
            )
          );
          setOfferFound(res?.data?.data?.offerProductFound);
          setCgst(res?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.billing?.sgst);
          setCess(res.data.data.billing.totalCessAmount);
          setTotal(res?.data?.data?.billing?.totalCartValue);
          setSubTotal(res?.data?.data?.billing?.subtotal);
          setDeleteLoader(false);
          setOpenDelete(false);
          dispatch(addcoupon(res?.data?.data?.billing?.appliedCoupon));
          document.activeElement.blur();
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setDeleteLoader(false);
          setOpenDelete(false);
        });
    }
  };

  const fourthrefElement = useRef(null);
  const quantityInputRef = useRef(null);

  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Tab") {
        return;
      }
      const focusableElements = fourthrefElement?.current?.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const firstElement = focusableElements?.[0];
      const lastElement = focusableElements?.[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    });
  }, []);

  const handleAddOnModal = () => {
    setAddOnModalOpen(true);
  };

  // Applies a cart response (from add or qty update) to the UI state
  const applyCartState = (data, products) => {
    setCartItems(products);
    if (products?.[0]?.cartProductId) {
      setHighlightedCartProductId(products[0].cartProductId);
      setTimeout(() => setHighlightedCartProductId(null), 2000);
    }
    setOfferFound(data?.offerProductFound);
    setCgst(data?.billing?.cgst);
    setSgst(data?.billing?.sgst);
    setCess(data?.billing?.totalCessAmount);
    setTotal(data?.billing?.totalCartValue);
    setTotalValue(data?.billing?.totalValue);
    setSubTotal(data?.billing?.subtotal);
    setTotalTaxes(data?.billing?.tax);
  };

  // Called when the user changes the variant inside the edit AddonModal.
  // A different variant is a different product, so it goes through the same
  // add-to-cart API as ProductsPage's
  // increseItemQuantityTroughParticularCategory (addRestaurantProducts),
  // with the qty picked in the modal's am-qty-selector.
  const handleAddVariantToCart = (variantId, addOn, comments, qty) => {
    const addonProducts = addOn?.map((item) => ({
      variantId: item?.variantId,
      itemName: item?.title,
      sellingPrice: item?.additionalPrice ?? 0,
      igst: Number(item?.gst) ?? 0,
      sellingUnit: item?.unitOfMeasure ?? "PCS",
      specification: item?.specification,
      quantity: item?.qty,
    }));

    const restaurantPayload = {
      variantId: variantId || "NA",
      cartId: cartId,
      locationId: locId,
      orgId: orgId,
      qty: qty != null && Number(qty) >= 1 ? Number(qty) : 1,
      addonProducts: addonProducts,
      ...(comments ? { comments } : {}),
    };

    addRestaurantProducts(restaurantPayload)
      .then((res) => {
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.status === "error" ||
          res?.data?.data?.es > 0
        ) {
          showSnackbar(
            res?.data?.message || res?.data?.data?.message || "Unable to update the item",
            "error"
          );
          setIncreaseLoader(false);
          return;
        }
        const response = res?.data?.data?.data;
        const sortedProducts = response?.cartProducts?.sort((a, b) =>
          b?.modifiedDate.localeCompare(a?.modifiedDate)
        );
        applyCartState(response, sortedProducts);
        showSnackbar("Item updated successfully", "success");
        setIncreaseLoader(false);
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setIncreaseLoader(false);
      });
  };

  const handleUpdateAddOns = (
    gtin,
    name,
    index,
    packaging_type,
    sellingUnit,
    variantId,
    sellingPrice,
    addOn,
    id,
    isBundle,
    productId,
    comments,
    qty = null
  ) => {
    setIncreaseLoader(true);

    // Variant changed → add the newly chosen variant instead of patching the
    // existing cart line's quantity.
    if (retailType === "RESTAURANT" && variantId && variantId !== ele?.variantId) {
      handleAddVariantToCart(variantId, addOn, comments, qty);
      return;
    }

    const transformedArray = addOn?.map((item) => ({
      addOnId: item?.addOnId ?? "",
      variantId: variantId,
      itemName: item.title,
      sellingPrice: item.additionalPrice || 0,
      quantity: item.qty || 1,
      igst: item.gst || 0,
      sellingUnit: item.unitOfMeasure ?? "PCS",
      specification: item.specification,
    }));

    if (retailType === "RESTAURANT") {
      const restaurantPayload = {
        variantId: variantId || "NA",
        cartId: cartId,
        cartProductId: ele?.cartProductId,
        locationId: locId,
        orgId: orgId,
        addonProducts: transformedArray,
        qty: ele?.quantity,
      };

      updateProductQuantityOnCart(restaurantPayload)
        .then((res) => {
          const sortedProducts = res?.data?.data?.data?.cartProducts?.sort((a, b) =>
            b?.modifiedDate.localeCompare(a.modifiedDate)
          );
          setCartItems(sortedProducts);

          if (sortedProducts?.[0]?.cartProductId) {
            setHighlightedCartProductId(sortedProducts[0].cartProductId);
            setTimeout(() => setHighlightedCartProductId(null), 2000);
          }

          setOfferFound(res?.data?.data?.data?.offerProductFound);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing.totalCessAmount);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setSubTotal(res?.data?.data?.data?.billing?.totalCartValue);

          showSnackbar("Add-ons updated successfully", "success");
          setIncreaseLoader(false);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setIncreaseLoader(false);
        });
    }
  };

  const customizeMessageForOutOfStock = () => {
    if (saleMode === "DELIVERY") {
      return "Delivery";
    }

    if (saleMode === "TAKE_AWAY") {
      return "Takeaway";
    }

    if (saleMode === "DINE_IN") {
      return "Dine In";
    }
  };

  const handleRepeatOrder = (e) => {
    e?.stopPropagation();
    setRepeatOrderLoader(true);
    const payload = {
      cartId: cartId,
      cartProductIds: [ele?.cartProductId],
      reorderedBy: retailUserLocalStorageData?.uidx,
      reorderedByName: retailUserLocalStorageData?.firstName,
    };
    repeatOrder(payload)
      .then((res) => {
        if (
          res?.data?.data?.es > 0 ||
          res?.data?.data?.data?.es > 0 ||
          res?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          showSnackbar(res?.data?.data?.message || "Unable to repeat the order", "error");
          setRepeatOrderLoader(false);
          return;
        }
        const repeatOrderData = res?.data?.data?.data;
        const cartProducts = res?.data?.data?.data?.cartProducts;
        setCartItems(cartProducts);
        // Highlight the most recently modified product (new repeat order item)
        if (cartProducts?.[0]?.cartProductId) {
          setHighlightedCartProductId(cartProducts[0].cartProductId);
          setTimeout(() => setHighlightedCartProductId(null), 2000);
        }
        setOfferFound(res?.data?.data?.data?.offerProductFound);
        setCgst(res?.data?.data?.data?.billing?.cgst);
        setSgst(res?.data?.data?.data?.billing?.sgst);
        setCess(res?.data?.data?.data?.billing?.totalCessAmount);
        setSubTotal(res?.data?.data?.data?.billing?.subtotal);
        setTotalTaxes(res?.data?.data?.data?.billing?.tax);
        setTotalValue(res?.data?.data?.data?.billing?.totalValue);
        setTotal(res?.data?.data?.data?.billing?.totalCartValue);
        setRepeatOrderLoader(false);
      })
      .catch((err) => {
        showSnackbar(err || res?.data?.data?.message || "Unable to repeat the order", "error");
        setRepeatOrderLoader(false);
      });
  };

  const handleRecallOrder = () => {
    if (managerPinRequiredForRecall) {
      openAuthModal(() => {
        setRecallOrderModalOpen(true);
      });
    } else {
      setRecallOrderModalOpen(true);
    }
  };

  return (
    <>
      <button
        id={
          animationBox && gtinItem === ele.gtin && highlightMrp == ele?.sellingPrice
            ? "myFocusDiv"
            : "myDiv3"
        }
        className={`${isHighlighted ? "cartItemHighlight" : ""} ${
          isKeyboardFocused ? "cart-item-keyboard-focused" : ""
        }`.trim()}
        style={{
          backgroundColor: isHighlighted
            ? undefined
            : index === 0 && branchSubType !== "FINE_DINE"
            ? "var(--Blue-B4, #d9f2ff)"
            : "#fff",
          marginTop: "5px",
          border: ele?.inventoryStatus === "OUT_OF_STOCK" ? "1px solid red" : "none",
        }}
      >
        <Modal
          open={openDelete}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title delete-text-theme" variant="h6" component="h2">
              Are you sure you want to delete
            </Typography>

            <Box className="save-wrapper-box">
              <Button className="save-wrapper-btn" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="save-wrapper-btn" onClick={() => handleCartDelete(ele)}>
                {deleteLoader ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Delete"}
              </Button>
            </Box>
          </Box>
        </Modal>
        <div className="cartMainContainer">
          {increaseCartItemLoader === index || deleteLoader ? (
            <CircularProgress color="success" sx={{ color: "#5271ff" }} size={30} />
          ) : (
            <>
              {/* Row 1: [food-dot + name + badges] ←→ [qty controls + price + trash] */}
              <div className="cartItemNameRow">
                {/* Left: food icon + product name + inline badges */}
                <div className="cartItemIconName">
                  {retailType === "RESTAURANT" && (
                    <div style={{ width: "14px", height: "14px", flexShrink: 0 }}>
                      <PosCustomIcon image={ele?.foodType === "VEG" ? vegIcon : nonVegIcon} />
                    </div>
                  )}
                  <div className="cartItemNameBadgeCol">
                    <div className="cartItemNameBadgeRow">
                      <p
                        className={`cartProductTitle ${
                          ele?.inventoryStatus === "REMOVED" ? "removedByKitchenItem" : ""
                        }`}
                        onClick={(e) => {
                          if (e.target.tagName !== "BUTTON" && e.target.tagName !== "IMG")
                            setCommentModalOpen(true);
                        }}
                      >
                        {ele?.productName}
                      </p>
                      {ele?.isBundle && (
                        <span className="cartItemBadge cartItemBadge--combo">Combo</span>
                      )}
                    </div>

                    {/* Variant name line */}
                    {retailType === "RESTAURANT" && ele?.variantName && (
                      <p className="cartItemVariantLine">{ele?.variantName}</p>
                    )}

                    {/* Add-on products line */}
                    {retailType === "RESTAURANT" && ele?.addonProduct?.length > 0 && (
                      <p className="cartItemAddonLine">
                        {ele?.addonProduct?.map((a, i) => {
                          const qty = a?.quantity || a?.qty;
                          return (
                            <span key={i}>
                              {i > 0 && ", "}
                              {a?.itemName}
                              {qty && qty > 0 && <span style={{ fontWeight: 600 }}> (x{qty})</span>}
                            </span>
                          );
                        })}
                      </p>
                    )}

                    {/* Complimentary */}
                    {ele?.inventoryStatus === "COMPLEMENTARY" && (
                      <span className="cartItemBadge cartItemBadge--complimentary">
                        Complimentary
                      </span>
                    )}

                    {/* Note */}
                    {ele?.comments && !increaseLoader && (
                      <p className="cartItemNoteInline">Note: {ele.comments}</p>
                    )}

                    {/* Edit > link — shown when item has addons and is user-requested */}
                    {ele?.productStatus === "USER_REQUESTED" &&
                      retailType === "RESTAURANT" &&
                      ele?.addonProduct?.length > 0 && (
                        <button className="cartItemEditLink" onClick={handleAddOnModal}>
                          Edit &rsaquo;
                        </button>
                      )}
                  </div>
                </div>

                {/* Right: qty controls */}
                {ele?.inventoryStatus !== "OUT_OF_STOCK" &&
                  ele?.productStatus === "USER_REQUESTED" && (
                    <div className="increaseDecreseButtonContainer">
                      {isWeighingBarcode ? (
                        <div style={{ paddingLeft: "4px", paddingRight: "4px" }}>
                          <img src={Scale} alt="scale" style={{ width: "15px", height: "15px" }} />
                        </div>
                      ) : (
                        <button
                          className="decreaseItemQuantity"
                          onClick={() => decreaseItemQuantity(ele, index)}
                        >
                          <img src={counterMinus} height={"12px"} width={"12px"} />
                        </button>
                      )}
                      <span
                        className="cartFormInput"
                        style={{ minWidth: `${Math.max(2, String(ele?.quantity)?.length) + 1}ch` }}
                      >
                        {ele?.quantity}
                      </span>
                      {!isWeighingBarcode && (
                        <button
                          className="increaseItemQuantity"
                          onClick={() => increaseItemQuantity(ele, index)}
                        >
                          <img src={counterPlus} height={"12px"} width={"12px"} />
                        </button>
                      )}
                    </div>
                  )}
              </div>

              {/* Row 2: price + trash */}
              <div className="cartItemControlsRow">
                <div className="priceAndTrashIcon">
                  {increaseLoader ? (
                    <CircularProgress size={24} />
                  ) : (
                    <p className="eachCartItemPrice">
                      {getStoreCurrencySymbol()}
                      {retailType === "RESTAURANT"
                        ? normalizeNumber(
                            Number(ele?.subTotal ?? 0) + Number(ele?.addonSubTotal ?? 0)
                          )
                        : normalizeNumber(ele?.mrpTotal ?? "")}
                    </p>
                  )}
                  {ele?.productStatus === "USER_REQUESTED" && (
                    <div className="trash-can-icon-border">
                      <PosCustomIcon
                        icon={<TrashIcon />}
                        height={"14px"}
                        width={"14px"}
                        color="#fb2c36"
                        pointer="true"
                        onClickFunction={() => handleCartDelete(ele)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {/* FINE_DINE sent items: Repeat / Recall buttons */}
          {ele?.productStatus !== "USER_REQUESTED" &&
            branchSubType === "FINE_DINE" &&
            saleMode === "DINE_IN" &&
            ele?.inventoryStatus !== "REMOVED" && (
              <div className="cartProductDetailsUpperContainerButton" style={{ marginTop: "4px" }}>
                {ele?.productStatus === "RETURNED" ? (
                  <p className="recallQuantityText">Returned x{ele?.quantity ?? ""}</p>
                ) : (
                  <>
                    {ele?.inventoryStatus !== "COMPLEMENTARY" && (
                      <PosCustomButton
                        title="Repeat Order"
                        variant="blue-s"
                        p={"6px 6px"}
                        onClickFunction={handleRepeatOrder}
                        radius="4px"
                        loading={repeatOrderLoader}
                        fontWeight={400}
                      />
                    )}
                    {ele?.inventoryStatus !== "COMPLEMENTARY" && (
                      <PosCustomButton
                        title="Recall Order"
                        variant="light-red"
                        p={"6px 6px"}
                        onClickFunction={handleRecallOrder}
                        radius="4px"
                        fontWeight={400}
                      />
                    )}
                  </>
                )}
              </div>
            )}

          {/* Out of stock */}
          {ele?.inventoryStatus === "OUT_OF_STOCK" && (
            <p className="outOfStockText">Not available for {customizeMessageForOutOfStock()}</p>
          )}

          {/* Removed by kitchen */}
          {ele?.inventoryStatus === "REMOVED" && (
            <div className="removedByKitchenStatus">
              <PosCustomIcon icon={<TrashIcon />} height={"16px"} width={"16px"} color="#dc2626" />
              <p>Removed by Kitchen</p>
            </div>
          )}
        </div>
        {addOnModalOpen && (
          <AddonModal
            addOnModalOpen={addOnModalOpen}
            setAddOnModalOpen={setAddOnModalOpen}
            selectedAddOns={ele?.addonProduct || []}
            productDetails={cartItems}
            itemName={ele?.productName}
            fetchVariantsFromAPI={true}
            selectedId={ele?.variantId}
            onAddItem={handleUpdateAddOns}
          />
        )}
      </button>
      {renderAuthModal()}
      <RecallOrderModal
        recallOrderModalOpen={recallOrderModalOpen}
        setRecallOrderModalOpen={setRecallOrderModalOpen}
        cartQuantity={cartQuantity}
        productTitle={ele?.variantName}
        cartProductId={ele?.cartProductId}
        setShowFineDineActionButtons={setShowFineDineActionButtons}
        setHasRequestedForNewItem={setHasRequestedForNewItem}
      />

      {commentModalOpen && (
        <ProductCommentModal
          open={commentModalOpen}
          handleClose={() => setCommentModalOpen(false)}
          product={ele}
          cartId={cartId}
          uidx={retailUserDetails?.uidx}
          userName={retailUserDetails?.firstName}
          onSaveSuccess={(cartProducts) => {
            // Update cart items from API response
            if (cartProducts && Array.isArray(cartProducts)) {
              const sortedProducts = cartProducts.sort((a, b) =>
                b?.modifiedDate.localeCompare(a?.modifiedDate)
              );
              setCartItems(sortedProducts);
            }
          }}
        />
      )}
    </>
  );
};

export default memo(CartItem);
